module.exports = __webpack_public_path__ + "img/secondary_7x4_z18.60182438.svg";